import { render, staticRenderFns } from "./TopbarWarning.vue?vue&type=template&id=31e1510c&scoped=true&"
import script from "./TopbarWarning.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TopbarWarning.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TopbarWarning.vue?vue&type=style&index=0&id=31e1510c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e1510c",
  null
  
)

export default component.exports